import { log } from 'lib/log';

export function sanitize(text: string) {
    log(`input html ==> ${text}`);
    log(`output text ==> ${text.replace(/<br\s*\/?>/gi, '')}`);

    return text.replace(/<br\s*\/?>/gi, '') as string;
}
